module.exports = "data:text/x-markdown;base64,VW5sb2NrIHRoZSB2YXVsdCB0byBwYXNzIHRoZSBsZXZlbCE="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/vault.md
// module id = 1413
// module chunks = 0